import {match, Pattern} from 'ts-pattern';

interface GetVisibleRowCountParams {
  naturalRows: number;
  regionHeight: number | null;
  rowHeight: number | null;
  rowSpan?: number;
  rowGap?: number;
  includesPartialRow?: boolean;
}

export const STRETCH_FACTOR = 2;

// Without this slack a sub-pixel measurement rounds up to another row and grows the region forever.
const EXACT_FIT_TOLERANCE = 1;

const countRows = (regionHeight: number, rowCost: number, includesPartialRow: boolean) =>
  includesPartialRow
    ? Math.max(0, Math.ceil((regionHeight - EXACT_FIT_TOLERANCE) / rowCost))
    : Math.floor(regionHeight / rowCost);

export function getVisibleRowCount(params: GetVisibleRowCountParams): number {
  const maximumRows = params.naturalRows * STRETCH_FACTOR * (params.rowSpan ?? 1);
  const rowGap = params.rowGap ?? 0;
  const includesPartialRow = params.includesPartialRow ?? false;

  return match(params)
    .with(
      {regionHeight: Pattern.number.gte(0), rowHeight: Pattern.number.gt(0)},
      ({naturalRows, regionHeight, rowHeight}) =>
        Math.min(
          naturalRows + countRows(regionHeight, rowHeight + rowGap, includesPartialRow),
          maximumRows
        )
    )
    .otherwise(({naturalRows}) => naturalRows);
}
